import { useState } from 'react'
import {
  Box,
  Divider,
  Flex,
  HStack,
  Icon,
  IconButton,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link, useLocation } from 'react-router-dom'

import { BsLayoutSidebarInset } from 'react-icons/bs'
import {
  FaGamepad,
  FaFacebook,
  FaTwitter,
  FaTiktok,
  FaInstagram,
  FaYoutube,
} from 'react-icons/fa'

// Game icons for the game categories nav items
import {
  GiSpinningSword,
  GiLaddersPlatform,
  GiWineGlass,
  GiBolterGun,
  GiJigsawPiece,
  GiPieSlice,
  GiCrossedAxes,
  GiBasketballBall,
  GiGuitarBassHead,
  GiBoulderDash,
  GiJumpAcross,
  GiFallDown,
} from 'react-icons/gi'

import LeaderBoredLogo from '../assets/Leaderbored_logo_HD.webp'
import homeIcon from "../assets/Nav-Icons/LBPortal_Graphic_Home.png";
import contactIcon from "../assets/Nav-Icons/LBPortal_Graphic_Contact.png";
import aboutIcon from "../assets/Nav-Icons/LeaderBored_Icon_About.png";
import bookIcon from "../assets/Nav-Icons/temp_book.png";
import newsIcon from "../assets/Nav-Icons/temp_news.png";


const MAIN_LINKS = [
  {
    label: 'Home',
    path: "/",
    icon: homeIcon,
  },
  {
    label: 'About',
    path: "/about",
    icon: aboutIcon,

  },
  {
    label: 'Comics',
    path: "/comics",
    icon: bookIcon,
  },
  {
    label: 'News',
    path: "/news",
    icon: newsIcon,
  },
  {
    label: 'Contact',
    path: "/contact",
    icon: contactIcon,
  },
]

const GAME_CATEGORIES_LINKS = [
  {
    path: "/g/combat",
    label: 'Combat',
    icon: GiSpinningSword
  },
  {
    path: "/g/cooking",
    label: 'Cooking',
    icon: GiPieSlice
  },
  {
    path: "/g/hyper-casual",
    label: 'Hyper-casual',
    icon: GiWineGlass
  },
  {
    path: "/g/multiplayer",
    label: 'Multiplayer',
    icon: GiCrossedAxes
  },
  {
    path: "/g/music",
    label: 'Music',
    icon: GiGuitarBassHead
  },
  {
    path: "/g/platformer",
    label: 'Platformer',
    icon: GiLaddersPlatform
  },
  {
    path: "/g/puzzle",
    label: 'Puzzle',
    icon: GiJigsawPiece
  },
  {
    path: "/g/rhythm",
    label: 'Rhythm',
    icon: GiBoulderDash
  },
  {
    path: "/g/shooter",
    label: 'Shooter',
    icon: GiBolterGun
  },
  {
    path: "/g/side-scroller",
    label: 'Side-scroller',
    icon: GiJumpAcross
  },
  {
    path: "/g/sorting",
    label: 'Sorting',
    icon: FaGamepad
  },
  {
    path: "/g/sports",
    label: 'Sports',
    icon: GiBasketballBall
  },
  {
    path: "/g/vertical-scroller",
    label: 'Vertical Scroller',
    icon: GiFallDown
  },
]

const SOCIAL_LINKS = [
  { link: 'https://www.instagram.com/leaderboredgg/', icon: <FaInstagram /> },
  { link: 'https://www.facebook.com/LeaderBoredGames/', icon: <FaFacebook /> },
  { link: 'https://twitter.com/LeaderBoredGG/', icon: <FaTwitter /> },
  {
    link: 'https://www.youtube.com/channel/UCVJjC7WCRuhe8ENydNuQTgQ',
    icon: <FaYoutube />,
  },
  { link: 'https://www.tiktok.com/@leaderboredgg', icon: <FaTiktok /> },
]

const Sidebar = ({ isSidebarToggled, setIsSidebarToggled }) => {
  const [isHovered, setIsHovered] = useState(false)
  const location = useLocation()

  const { pathname } = location
  const collapsedWidth = '60px'
  const expandedWidth = '240px'

  return (
    <>
      <Box
        as='nav'
        bg='rgba(38, 122, 194, 0.95)'
        color='white'
        h='100vh'
        w={isHovered ? expandedWidth : collapsedWidth}
        overflow='hidden' // for redundancy's sake?
        boxShadow='4px 0 10px rgba(0,0,0,0.2)'
        backdropFilter='blur(4px) saturate(180%)'
        // display={isSidebarToggled ? 'none' : 'flex'}
        display='flex'
        flexDirection='column'
        position='fixed'
        zIndex='1000'
        top='0'
        left={isSidebarToggled ? '-300px' : '0'}
        transition={
          `left 0.5s ease,
          width 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)`
        }
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <VStack
          spacing={0}
          align='stretch'
          flex='1'
          overflowY='auto'
          overflowX='hidden'
          // css={{
          //   '&::-webkit-scrollbar': {
          //     width: '4px',
          //   },
          //   '&::-webkit-scrollbar-track': {
          //     background: 'transparent',
          //   },
          //   '&::-webkit-scrollbar-thumb': {
          //     background: 'rgba(255, 255, 255, 0.3)',
          //     borderRadius: '24px',
          //   },
          // }}
          sx={{
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgba(255, 255, 255, 0.3) transparent',
          }}
          pb={4}
        >
          <Box
            py={4}
            px={3}
            bg='blackAlpha.200'
            borderBottom='1px solid'
            borderColor='whiteAlpha.300'
            display={isHovered ? 'block' : 'none'}
          >
            <Flex flexDirection='row' align='center' justifyContent='space-between'>
              <Link to='/'>
                <Image w='72px' src={LeaderBoredLogo} alt='Leaderbored logo' />
              </Link>

              <IconButton
                onClick={() => setIsSidebarToggled(!isSidebarToggled)}
                size='sm'
                variant='ghost'
                color='white'
                _hover={{ bg: 'white', color: '#4078bd' }}
                icon={<BsLayoutSidebarInset />}
                aria-label='Social Media'
              />
            </Flex>
          </Box>

          {/* Main Links */}
          <VStack align='stretch' spacing={1}>
            {MAIN_LINKS.map(link => (
              <NavItem
                isActive={pathname === link.path}
                key={link.label}
                iconImage={link.icon}
                label={link.label}
                isExpanded={isHovered}
                link={link.path}
              />
            ))}
          </VStack>

          <Divider my={4} borderColor='whiteAlpha.500' />

          {/* Category Links */}
          <VStack align='stretch' spacing={1}>
            {GAME_CATEGORIES_LINKS.map(cat => (
              <NavItem
                isActive={pathname === `/c/${cat.path}`}
                key={cat.label}
                icon={cat.icon}
                label={cat.label}
                isExpanded={isHovered}
                link={cat.path}
              />
            ))}
          </VStack>
        </VStack>

        {/* Media Buttons */}
        <Box
          p={4}
          bg='blackAlpha.200'
          borderTop='1px solid'
          borderColor='whiteAlpha.300'
          display={isHovered ? 'block' : 'none'}
        >
          <Text fontSize='sm' mb={3} fontWeight='bold' textAlign='center'>
            Leaderbored © 2025
          </Text>
          <HStack justify='center' spacing={4}>
            {SOCIAL_LINKS.map(social => (
              <Link target='_blank' to={social.link} key={social.link}>
                <SocialBtn icon={social.icon} />
              </Link>
            ))}
          </HStack>
        </Box>
      </Box >
    </>
  )
}

const NavItem = ({ icon = undefined, iconImage = undefined, label, link, isActive, isExpanded }) => {
  return (
    <Flex
      align='center'
      p={3}
      cursor='pointer'
      _hover={{ borderLeft: '4px solid white', bg: 'rgba(255, 255, 255, 0.1)', pl: 2 }}
      role='group'
      transition='background 0.2s'
      justify={isExpanded ? 'flex-start' : 'center'} // Center icon when collapsed
      css={isActive && { borderLeft: '4px solid white', bg: 'rgba(255, 255, 255, 0.1)', pl: 2 }}
      h='50px'
      as={Link}
      to={link}
      state={{ pageTitle: label }}
    >
      {/* conditional rendering for icon image vs icon component */}
      {iconImage && <Image
        maxH='1em'
        src={iconImage}
        alt='Navigation icon'
        mr={isExpanded ? 4 : 0} />
      }

      {icon && <Icon
        as={icon}
        boxSize={5}
        // Add a slight margin only if we have text to show
        mr={isExpanded ? 4 : 0}
      />}

      {/* We use opacity and max-width transitions for a smooth reveal effect. */}
      <Box
        opacity={isExpanded ? 1 : 0}
        width={isExpanded ? 'auto' : 0}
        overflow='hidden'
        whiteSpace='nowrap'
        transition='all 0.2s'
      >
        <Text fontSize='md' fontWeight='medium'>
          {label}
        </Text>
      </Box>
    </Flex>
  )
}

const SocialBtn = ({ icon }) => (
  <IconButton
    size='sm'
    variant='ghost'
    color='white'
    _hover={{ bg: 'white', color: '#4078bd' }}
    icon={icon}
    aria-label='Social Media'
  />
)

export default Sidebar
